module.exports = __webpack_public_path__ + "a568ee99d4bc65813cb1776c478296ae.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_stacked_bar_3month_show.png
// module id = 906
// module chunks = 7